import { render, staticRenderFns } from "./AllocationRule.vue?vue&type=template&id=42adedeb&scoped=true"
import script from "./AllocationRule.vue?vue&type=script&lang=js"
export * from "./AllocationRule.vue?vue&type=script&lang=js"
import style0 from "./AllocationRule.vue?vue&type=style&index=0&id=42adedeb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42adedeb",
  null
  
)

export default component.exports